import { selectIsWhatsAppMessageChannelGAFlagOn } from 'core/userContext/selectors';
import { WhatsAppEspAccount } from 'modules/graphql';
import { pluralResourcesText } from 'modules/sendingPlatforms/utils/text';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { InfoBanner } from 'ui/banner';
import { BUTTON_SIZES, GhostInfoButton } from 'ui/button';
import {
  ARROW_DIRECTION_DOWN,
  CollapsibleContent,
  CollapsibleContentArrow,
} from 'ui/collapsibleContent';
import { spacing } from 'ui/theme';

import {
  AccountDetails,
  AccountName,
  ArrowButton,
  LeftContent,
  Main,
  RightContent,
  SectionHeading,
  Wrapper,
} from '../AccountsSection.styled';
import { BusinessProfilesTakeover } from './BusinessProfilesTakeover';
import { WhatsAppChannelRow } from './WhatsAppChannelRow';

const AccountInfoBanner = styled(InfoBanner)`
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding: ${spacing.threeQuarter}
  && {
    border-bottom-width: 0;
  }
  align-items: center;
`;

type Props = { espAccount: WhatsAppEspAccount };

export const WhatsAppAccount = ({ espAccount }: Props) => {
  const isWhatsAppGAEnabled = useSelector(selectIsWhatsAppMessageChannelGAFlagOn);

  const [isExpanded, setIsExpanded] = useState(false);

  const { name, id, senders } = espAccount;
  const channelTerm = 'messaging profile';
  const senderLength = senders?.length || 0;
  const collapseBtnText = `${pluralResourcesText(senderLength, channelTerm)}`;
  const handleRefresh = () => window.location.reload();
  const incompleteProfile = !senderLength || senders.some((sender) => !sender.displayName);
  return (
    <>
      {incompleteProfile && (
        <AccountInfoBanner
          BannerActions={<GhostInfoButton onClick={handleRefresh}>Refresh</GhostInfoButton>}
        >
          Setting up your WhatsApp sender (this may take up to an hour). If you don't see your
          account details shortly, try refreshing the page.
        </AccountInfoBanner>
      )}
      <Wrapper className={incompleteProfile ? 'hasBanner' : ''} data-test="WhatsApp-account-test">
        <Main>
          <LeftContent>
            <AccountName>{name}</AccountName>
            <AccountDetails>ID: {id}</AccountDetails>
          </LeftContent>
          <RightContent>
            <ArrowButton onClick={() => setIsExpanded(!isExpanded)} size={BUTTON_SIZES.SMALL}>
              <span>{collapseBtnText}</span>
              <CollapsibleContentArrow
                isCollapsed={!isExpanded}
                arrowStart={ARROW_DIRECTION_DOWN}
                arrowEnd={180}
                width={16}
                height={16}
              />
            </ArrowButton>
          </RightContent>
        </Main>
        {!!senderLength && (
          <CollapsibleContent isCollapsed={!isExpanded}>
            <SectionHeading>{isWhatsAppGAEnabled ? 'senders' : 'business profiles'}</SectionHeading>
            {senders.map((sender) => (
              <WhatsAppChannelRow key={sender.id} sender={sender} />
            ))}
          </CollapsibleContent>
        )}
        <BusinessProfilesTakeover />
      </Wrapper>
    </>
  );
};
